import { gql } from "@urql/core"

export const UPDATE_PRACTICE_SCRIPTS_MUTATION = gql`
  mutation UpdatePracticeScripts($headScripts: String, $bodyScripts: String) {
    updatePracticeScripts(headScripts: $headScripts, bodyScripts: $bodyScripts) {
      result
      errors
      practice {
        id
        headScripts
        bodyScripts
      }
    }
  }
`
